import { FC, useState } from 'react';

import VideoCustom from 'molecules/VideoCustom';

import PrimaryButton from 'components/FreeTrialFTUX/ui/PrimaryButton';
import StepShell from 'components/FreeTrialFTUX/ui/StepShell';

import type { ImageConfig } from 'molecules/Image/config';

interface VideoStepProps {
  heading: string;
  description: string;
  caption: string;
  videoSrc?: string;
  videoThumbnail?: ImageConfig['image'];
  nextLabel: string;
  skipLabel: string;
  onNext: (watched: boolean) => void;
  onSkip: () => void;
  isTransitioning: boolean;
}

const VideoStep: FC<VideoStepProps> = ({
  heading,
  description,
  caption,
  videoSrc,
  videoThumbnail,
  nextLabel,
  skipLabel,
  onNext,
  onSkip,
  isTransitioning,
}) => {
  const [played, setPlayed] = useState(false);

  return (
    <StepShell
      heading={heading}
      description={description}
      stepNumber={3}
      onSkip={onSkip}
      skipLabel={skipLabel}
      isTransitioning={isTransitioning}
      rightPanel={
        <div className="flex flex-col gap-3">
          <p className="font-roboto text-sm font-semibold leading-5 text-ftux-label">{caption}</p>
          <VideoCustom
            videoSrc={videoSrc}
            thumbnail={videoThumbnail}
            onPlay={() => setPlayed(true)}
            className="!mx-0 max-w-full"
          />
        </div>
      }
      bottomAction={<PrimaryButton onClick={() => onNext(played)}>{nextLabel}</PrimaryButton>}
    />
  );
};

export default VideoStep;
